















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { get } from 'lodash-es';
import api from '@/api';
import constants from '@/utils/constants';
import SimpleKeyboard from '@/components/SimpleKeyboard/index.vue';

@Component({
  components: {
    SimpleKeyboard,
  }
})
export default class PinCode extends Vue {
  @Prop() callback!: Function;

  $swal: any;
  maxPinLength: number = 4;
  pinCode: string = '';
  fetching: boolean = false;

  @Watch('pinCode')
  watchPinCode(value) {
    if (value.length === this.maxPinLength) {
      this.pinCode = this.pinCode.slice(0, this.maxPinLength);
      this.checkPinCode();
    }
  }

  onChange(input) {
    this.pinCode = input;
  }

  async checkPinCode() {
    this.fetching = true;
    try {
      const outletData = JSON.parse(localStorage.getItem('outletData') || '{}');
      const { outlet_code } = outletData;
      const res = await api.CheckPinCode({ outletCode: outlet_code, pinCode: this.pinCode });
      if (res.data.invalidMessage === constants.UPPER_SUCCESS) {
        const resStatus = get(res.data, 'data.validate', false);
        if (resStatus) {
          sessionStorage.setItem('pin_code', this.pinCode);
          this.$emit('callback');
        } else {
          this.pinCode = '';
          this.$swal(
            constants.SOMETHING_WROING,
            'Pin code is not valid',
            constants.STATUS_ERROR
          );
        }
      } else {
        return this.$swal(
          constants.SOMETHING_WROING,
          res.data.invalidMessage,
          constants.STATUS_ERROR
        )
      }
    } catch (error) {
      this.$swal(
        constants.SOMETHING_WROING,
        error,
        constants.STATUS_ERROR
      );
    }
    this.fetching = false;
  }
}
